module.exports = __webpack_public_path__ + "img/privacy-ex-3.19b4277f.png";